import { useEffect, useRef } from "react";
// import {
//   Resource,
//   ResourceCategory,
//   resources,
// } from "../../utils/dataHelpers/resources-data";
import Layout from "../../components/layout/layout";
// import ResourceFilters from "../../components/library/filters/resource-filters";
// import ResourceCard from "../../components/library/cards/resource-card";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import NoDataImage from "../../assets/images/nodata.png";

// function filterResources(
//   list: Resource[],
//   searchTerm: string,
//   activeCategory: ResourceCategory,
// ): Resource[] {
//   const term = searchTerm.trim().toLowerCase();

//   return list.filter((item) => {
//     const matchesCategory =
//       activeCategory === "All Resources" || item.category === activeCategory;

//     const matchesSearch =
//       !term ||
//       item.title.toLowerCase().includes(term) ||
//       item.description.toLowerCase().includes(term);

//     return matchesCategory && matchesSearch;
//   });
// }

const ResourcePage = () => {
  // const [searchTerm, setSearchTerm] = useState<string>("");
  // const [activeCategory, setActiveCategory] =
  //   useState<ResourceCategory>("All Resources");

  const pageRef = useRef<HTMLDivElement | null>(null);

  // const filteredResources = useMemo(
  //   () => filterResources(resources, searchTerm, activeCategory),
  //   [searchTerm, activeCategory],
  // );

  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger);

    const ctx = gsap.context(() => {
      // HERO INTRO
      const heroTl = gsap.timeline({
        defaults: { ease: "power3.out", duration: 0.7 },
      });

      heroTl
        .from(".resource-hero-title", {
          y: 24,
          opacity: 0,
        })
        .from(
          ".resource-hero-subtitle",
          {
            y: 28,
            opacity: 0,
          },
          "-=0.4",
        );

      // FILTERS SECTION
      gsap.from(".resource-filters-section", {
        y: 30,
        opacity: 0,
        duration: 0.7,
        ease: "power3.out",
        scrollTrigger: {
          trigger: ".resource-filters-section",
          start: "top 80%",
          toggleActions: "play none none reverse",
        },
      });

      gsap.from(".resource-grid", {
        y: 40,
        opacity: 0,
        duration: 0.8,
        ease: "power3.out",
        scrollTrigger: {
          trigger: ".resource-grid",
          start: "top 80%",
          toggleActions: "play none none reverse",
        },
      });

      gsap.from(".resource-card", {
        y: 30,
        opacity: 0,
        duration: 0.6,
        ease: "power3.out",
        stagger: 0.08,
        scrollTrigger: {
          trigger: ".resource-grid",
          start: "top 75%",
          toggleActions: "play none none reverse",
        },
      });
    }, pageRef);

    return () => ctx.revert();
  }, []);

  return (
    <Layout>
      <div ref={pageRef} className="space-y-8 pb-16">
        <section
          className="
            relative bg-[#2C73DB] 
            rounded-bl-[80px] rounded-br-[80px]
            md:rounded-bl-[160px] md:rounded-br-[160px]
            lg:rounded-bl-[200px] lg:rounded-br-[200px]
            text-white pt-32 flex items-end justify-center
          "
        >
          <div className="max-w-5xl relative px-4 sm:px-6">
            <div className="loyalty-hero-heading text-center mb-[30%] md:mb-[15%]">
              <h1 className="resource-hero-title text-2xl md:text-3xl lg:text-4xl font-medium leading-tight mb-4 px-2">
                Resource Center
              </h1>
              <p className="resource-hero-subtitle text-sm md:text-base text-blue-100 max-w-2xl mx-auto leading-relaxed">
                Access our collection of whitepapers, case studies, guides, and
                reports to help you succeed with SMS marketing
              </p>
            </div>
          </div>
        </section>

        <div className="space-y-4 rounded-[40px] md:rounded-[60px] text-[#000] bg-[#f0f6ff] p-12 flex flex-col items-center max-w-6xl mx-auto ">
          <h1 className="text-xl lg:text-3xl font-medium ">Coming Soo!!!</h1>
          <img src={NoDataImage} alt="No Data" className="mx-auto mt-4" />
          <h3>Check Back With Us Soon</h3>
        </div>
        {/* <div className="resource-filters-section relative mx-auto max-w-4xl px-6 mb-24">
          <ResourceFilters
            searchTerm={searchTerm}
            onSearchChange={setSearchTerm}
            activeCategory={activeCategory}
            onCategoryChange={setActiveCategory}
          />
        </div>

        <div className="relative mx-auto max-w-6xl bg-[#F0F6FF] px-6 py-12 md:p-12 rounded-[60px]">
          <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
            {filteredResources.map((resource) => (
              <div key={resource.id} className="resource-card">
                <ResourceCard resource={resource} />
              </div>
            ))}
          </div>
        </div> */}
      </div>
    </Layout>
  );
};

export default ResourcePage;
